import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IUpcomingSwapCallsReportResponse } from '@nkr/store/index';
import Tabs from '@nkr/views/swap-management/tabs-new';
import CourierSwapCallsScheduleReportGrid from '../../courier-swap-calls-schedules/courier-swap-calls-schedules-grid';
import { IUser } from '@nkr/models/index';

interface IOwnProps { }

interface IStateProps {
    user: IUser,
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getUpcomingSwapCallsReport: (courierVendor: number) => Promise<IUpcomingSwapCallsReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
}

class SwapCallsScheduleReport extends React.Component<TProps, IState> {
    render = () => {
        return (
            <>
                <Tabs tabKey='SCHED' subTabKey='' counts={null} user={this.props.user} />

                <CourierSwapCallsScheduleReportGrid
                    courierVendor={0}
                    getUpcomingSwapCallsReport={this.props.getUpcomingSwapCallsReport}
                    showLoading={this.props.showLoading}
                    hideLoading={this.props.hideLoading}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        user: appState.app.user,
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getUpcomingSwapCallsReport: (courierVendor) => {
            return dispatch(ReportActionCreators.getUpcomingSwapCallsReport(courierVendor));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(SwapCallsScheduleReport);